import { OvieCallableError } from '@principle-theorem/ng-ai-suite';
import { OvieHealthErrorCode } from '@principle-theorem/principle-core/interfaces';

export function ovieHealthErrorMessage(error: OvieCallableError): string {
  switch (error.code) {
    case OvieHealthErrorCode.KnowledgeBaseNotFound:
      return 'No knowledge base found for this practice.';
    case OvieHealthErrorCode.KnowledgeBaseNotConfigured:
      return 'Ovie Health is not configured for this practice.';
    case OvieHealthErrorCode.KnowledgeBasePracticeAccessDenied:
    case OvieHealthErrorCode.SettingsPracticeAccessDenied:
      return 'Access denied by Ovie Health for this practice.';
    case OvieHealthErrorCode.WrongPmsType:
      return 'Ovie Health data is not available for this practice type.';
    case OvieHealthErrorCode.OvieHealthRateLimited:
      if (typeof error.retryAfterMs === 'number') {
        return `Rate limited. Retry after ${Math.ceil(
          error.retryAfterMs / 1000
        )} seconds.`;
      }
      return 'Rate limited. Please try again later.';
    case OvieHealthErrorCode.OvieHealth5xx:
      return 'Ovie Health is temporarily unavailable. Please try again later.';
    case OvieHealthErrorCode.OvieHealthTimeout:
      return 'The request to Ovie Health timed out. Please try again.';
    case OvieHealthErrorCode.OvieHealthNetwork:
      return 'Network error. Please check your connection and try again.';
    default:
      return 'Unexpected error fetching Ovie Health data. Please try again.';
  }
}
